// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"69b970ba","453":"b223a19e","553":"68560e02","762":"df0e22e1","977":"018f1712"}[chunkId] + ".chunk.js";
};